import type { IAuthFieldProps } from './IAuthFieldProps';

/** Поле форми входу (прототип v4): підпис 12px/500 muted над полем 36px; фокус — рамка акценту з кільцем --accent-soft. */
export function AuthField({ label, type, value, placeholder, autoComplete, onChange, inputMode, autoFocus }: IAuthFieldProps) {
  return (
    <label className="au__field">
      <span className="au__label">{label}</span>
      <input className="au__input" type={type} value={value} placeholder={placeholder} aria-label={placeholder} autoComplete={autoComplete}
        inputMode={inputMode} autoFocus={autoFocus} onChange={(e) => onChange(e.target.value)} />
    </label>
  );
}
